import { put, call } from 'redux-saga/effects';
import { DirectMessageAction, UIAction } from '../actions';
import { DirectMessageService } from '../services';
import { generateReadableError } from 'hooks';

export function* getMessages(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(DirectMessageAction.fetchDirectMessageSuccess(null));
  try {
    const { data } = yield call(DirectMessageService.getInstance().getMessages, action.payload);
    yield put(DirectMessageAction.fetchDirectMessageSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* sendDirectMessages(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(DirectMessageAction.sendDirectMessageSuccess(null));
  try {
    const { data } = yield call(DirectMessageService.getInstance().sendMessage, action.payload);
    yield put(DirectMessageAction.sendDirectMessageSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(DirectMessageAction.sendDirectMessageSuccess({data:{timestamp:action.payload.timestamp, pending:2}}));
    yield put(UIAction.showLoading(false));
  }
}







